import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Reviews from "@/pages/Reviews";
import Admin from "@/pages/Admin";

function App() {
    useLenis();
    return (
        <div className="App">
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/book" element={<Booking />} />
                    <Route path="/reviews" element={<Reviews />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Footer />
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
